import React from "react";
import { FormControl, FormLabel, Rating, RatingProps } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { visuallyHidden } from "@mui/utils";

export const RatingHighContrast: React.FC<RatingProps> = (props) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" sx={visuallyHidden}>
        Book rating
      </FormLabel>
      <Rating
        {...props}
        icon={<StarIcon fontSize="inherit" htmlColor="#d77e02" />}
        emptyIcon={<StarBorderIcon fontSize="inherit" htmlColor="#99948F" />}
        sx={{
          "& input": {
            color: "#000000",
          },
        }}
      />
    </FormControl>
  );
};
